export const HEADER_NOTIFICATIONS = {
    NOTIFICATIONS_HEADER: "notifications-header",
    NOTIFICATIONS_CONTENT: "notifications-content",
    NOTIFICATIONS_GROUP: "notifications-group",
    NOTIFICATIONS_GROUP_HEADER: "notifications-group-header",
    NOTIFICATIONS_GROUP_CONTENT: "notifications-group-content",
    NOTIFICATIONS_GROUP_MORE: "notifications-group-more",
    NOTIFICATIONS_ROW: "notifications-row",
    NOTIFICATIONS_LINK_CONTENT: "notifications-link-content",
};
